<template>
  <div class="search-module">
    <form class="search-form search-form-expanded" v-on:submit.prevent="onSubmit">
      <div class="input-group" style="margin-left: 20px" v-bind:class="{'open':openSuggestion}">
        <input type="text" class="form-control" placeholder="Search..." autocomplete="off" name="query" v-model="selectionVal" @keydown.enter.prevent = 'enter' @keydown.down = 'down' @keydown.up = 'up' @input = 'change' @blur="hide">
        <span class="input-group-btn">
                <button class="btn submit-search" @click.prevent="showModal()">
                  <i class="icon-magnifier" style="margin-top: 3px;"></i>
                </button>
        </span>
        <ul class="dropdown-menu" style="width:100%">
          <li v-if="noMatchesFound()" v-on:click="onSubmit()"><a>{{ notFound }}</a></li>
          <li v-for="(suggestion, index) in matches" v-bind:class="{'active': isActive(index)}" v-on:click="suggestionClick(suggestion)">
            <a>{{ suggestion.participant_name }}</a>
          </li>
        </ul>
      </div>
    </form>
  </div>
</template>
<script>
  import { HTTP, ERROR } from '@/http-common';
  import { mapGetters } from 'vuex';
  import _ from 'lodash';

  export default {
    props: {
      selection: {
        type: String,
        required: true,
        twoWay: true
      },
    },

    data () {

      return {
        open: false,
        current: 0,
        selectionVal: this.selection,
        matchesLength: '',
        notFound: 'Sorry, no search results were found.',
        matches: '',
        postData: {
          keyword: this.selection
        }
      }

    },

    watch: {
      selection: function () {
        this.selectionVal = this.selection;
      },
      selectionVal: function () {
        this.getSuggestions();
      }
    },

    computed: {
      ...mapGetters({
        user: 'getUser'
      }),
      openSuggestion() {
        return this.selectionVal !== "" &&
               this.open === true;
      }
    },

    methods: {
      enter() {
        if (typeof this.matches[this.current] != 'undefined'){
          this.$router.push({ name: 'Dashboard Participant', params: { id: this.matches[this.current].id } });
          this.selectionVal = '';
        } else {
          this.onSubmit();
        }
        this.open = false;
      },

      up() {
        if (this.current > 0) {
          this.current--;
        }
      },

      down() {
        if (this.current < this.matches.length - 1) {
          this.current++;
        }
      },

      isActive(index) {
        return index === this.current;
      },

      change() {
        if (this.open == false) {

          this.open = true;
          this.current = 0;
        }
      },

      hide() {
        setTimeout(() => {
          this.open = false;
          this.matches = [];
        }, 500);
      },

      noMatchesFound() {
        return this.matches.length === 0;
      },

      suggestionClick(data) {
        this.open = false;
        this.$router.push({ name: 'Dashboard Participant', params: { id: data.id } });
        this.selectionVal = '';
      },

      onSubmit() {
        this.$emit('searchQuery', this.selectionVal);
        $('#search_modal').modal('show');
        this.selectionVal = '';
      },

      passData(data) {
        this.matches = data;
      },

      showModal() {
        this.$emit('searchQuery', this.selectionVal);
        this.$emit('openSearchModal', true);
      },

      getSuggestions:
        _.debounce(
          function () {
            //console.log(this.selectionVal);
            HTTP.post(`search`, {keyword: this.selectionVal})
              .then(results => {
                if(results.status === 200) {
                  this.passData(results.data.data.rows);
                }
                ERROR(results);
              }).catch(err => {
                console.log(err);
            })
          }, 500
        )
    }
  }
</script>
<style lang="scss" scoped>
  .dropdown-menu {
    top:45px;
  }
  .external {
    display: block;
    overflow: hidden;
    padding: 10px 15px;
    letter-spacing: .5px;
    background: #eaedf2;
    border-radius: 0;

    &:hover a{
       background-color: transparent;
     }
    a {
      margin: 0;
      padding: 0;
      float: left;
      font-size: 13px;
      display: inline-block;
      cursor: pointer;
      &:hover, &:focus {
        background-color: transparent;
       }
    }
  }
  .btn.submit-search {
    margin-left: 0;
    padding: 0;
    width: 32px;
    background-color: #d09f23;
    margin-top: 1px;
    display: block;
    height: 32px !important;
    border-radius: 0 !important;
    transition: all .3s;

    &:hover {
      background-color: #c79516;
      border-color: #c79516;
    }

    i {
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// Autocomplete.vue?15276736